// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "(max-width: 1024px)";
var _3 = "header-3QT9-";
var _4 = "header__name-2Jz64";
var _5 = "charge-1-ZMW";
var _6 = "flight__container-3Rrnu";
var _7 = "money-CgNOg";
var _8 = "total__money-2Pt-l";
var _9 = "total-24RtQ";
export { _1 as "__esModule", _2 as "tablet", _3 as "header", _4 as "header__name", _5 as "charge", _6 as "flight__container", _7 as "money", _8 as "total__money", _9 as "total" }
export default { "__esModule": _1, "tablet": _2, "header": _3, "header__name": _4, "charge": _5, "flight__container": _6, "money": _7, "total__money": _8, "total": _9 }
